export * from 'cf-core/src/images'
export const Hero404 =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1582791158/general/404Hero.png'
export const appStore =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/app-store.png'
export const cftitle =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/cftitle.png'
export const googlePlay =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/google-play.png'
export const user =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/user.png'
export const sharedBg =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1582514489/general/marblebgdefault.jpg'
export const orderStatusProgress =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1554602154/general/OrderStatusProgress.png'
export const orderStatusMeter =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1554666730/general/OrderStatusMeter.png'
export const promoHeader =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/Shaolin/promoHeader.png'
export const restaurant =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1562129124/Shaolin/restaurant.jpg'
export const yelp =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1601869832/general/yelp_white.png'
export const facebook =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1601869832/general/facebook_white.png'
export const zomato =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1601869833/general/zomato_white.png'
export const instagram =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1601869833/general/instagram_white.png'
export const contactMobilebg =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/contactMobilebg.jpg'
export const rewardbg =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardbg.jpg'
export const downloadButton =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/downloadButton.png'
export const flowerTL =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/flowerTL.png'
export const flowerBR =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/flowerBR.png'
export const redeemButton =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/redeemButton.png'
export const pointsMeter =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/pointsMeter.png'
export const rewardArrowLeft =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardArrowLeft.png'
export const rewardArrowRight =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardArrowRight.png'
export const rewardDefault =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardDefault.png'
export const cflogo =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1591377852/general/cflogo_black.png'
export const about =
  'https://duz5wmfjpigi0.cloudfront.net/about.webp?format=auto'
export const contactbg =
  'https://duz5wmfjpigi0.cloudfront.net/contactbg.webp?format=auto'
export const hero =
  'https://duz5wmfjpigi0.cloudfront.net/hero2.webp?format=auto'
export const heroText = 'https://duz5wmfjpigi0.cloudfront.net/heroText2.png'
export const locationMap =
  'https://duz5wmfjpigi0.cloudfront.net/locationMap.webp?format=auto'
export const logo = 'https://duz5wmfjpigi0.cloudfront.net/logo.webp?format=auto'
export const mobileAbout =
  'https://duz5wmfjpigi0.cloudfront.net/mobileAbout.webp?format=auto'
export const mobileContactbg =
  'https://duz5wmfjpigi0.cloudfront.net/mobileContactBg.webp?format=auto'
export const mobileHero =
  'https://duz5wmfjpigi0.cloudfront.net/mobileHero2.webp?format=auto'
export const mobileHeroText =
  'https://duz5wmfjpigi0.cloudfront.net/mobileHeroText.webp?format=auto'
export const mobileMap =
  'https://duz5wmfjpigi0.cloudfront.net/mobileMap.webp?format=auto'
export const mobilePromo1 =
  'https://duz5wmfjpigi0.cloudfront.net/mobilePromo1-2.webp'
export const mobilePromo2 =
  'https://duz5wmfjpigi0.cloudfront.net/mobilePromo2.webp?format=auto'
export const mobilePromo3 =
  'https://duz5wmfjpigi0.cloudfront.net/mobilePromo3-2.webp'
export const mobilePromo4 =
  'https://duz5wmfjpigi0.cloudfront.net/mobilePromo4.webp?format=auto'
export const orderPickupButton =
  'https://duz5wmfjpigi0.cloudfront.net/orderButton.webp?format=auto'
export const promotions =
  'https://duz5wmfjpigi0.cloudfront.net/promotions4.webp'
